import React, { useEffect, useState } from 'react';
import '../../css/Dashboard.css';
import { useDashboardData } from './DashboardDataContext';

const FollowUpsComponent = () => {
  const [followUps, setFollowUps] = useState<any[]>([]);
  const { data } = useDashboardData();
  useEffect(() => {
    if (!data) return;
    const list = (data.followups||[]).map((f:any)=>({
      name: f.customerName || f.customer?.name || '—',
      date: f.date || f.followupDate || '',
      time: (f.time || '').substring(0,5),
      task: f.description || f.queryType || ''
    }));
    setFollowUps(list);
  }, [data]);

  return (
    <div className="card">
      <div style={{ padding: 10, borderBottom: '1px solid #ddd' }}>
        <h4 style={{ margin: 0 }}>Today's Follow-ups</h4>
      </div>
      <div style={{ padding: 8 }}>
        {followUps.map((f, i) => (
          <div key={i} className="list-item">
            <div>
              <div className="li-title">{f.name}</div>
              <div className="li-sub">Due {f.date ? new Date(f.date).toLocaleDateString() : ''} {f.time ? `· ${f.time}` : ''}</div>
              <div className="li-sub" style={{ marginTop: 4 }}>{f.task}</div>
            </div>
            <button className="btn" onClick={() => alert('Marked Done')}>Mark Done</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FollowUpsComponent;
